import React, { useEffect } from 'react'
import AboutPage from '../Components/About'

const Aboutpage = () => {
    useEffect(() => {
        window.scrollTo(0, 0); // Scrolls to top when component loads
      }, []);
  return (
    <div className='py-10'>
      <AboutPage/>
    </div>
  )
}

export default Aboutpage
